<template>
	<div class="separator" :style="{'--h': h}"></div>
</template>
<script>
	export default {
		name: 'SimplementsSeparator',
		props: {
			h: {
				type: String,
				default: '24px'
			}
		}
	}
</script>
<style scoped>
	@import url(./assets/basic.css);
	.separator{
		height: var(--h);
	}
</style>